import { UserDTO } from '@/models';
import { axiosBase } from './axios-base';

export const fetchAllAdmin = (): Promise<{ data: UserDTO[] }> => {
  return axiosBase.get('/api/config/admins');
};

export const addNewAdmin = (userId: number): Promise<{data: UserDTO[]}> => {
  return axiosBase.post(`/api/config/admin?userId=${userId}`)
}

export const removeAdmin = (userId: number): Promise<{data: UserDTO[]}> => {
  return axiosBase.post(`/api/config/admin/remove?userId=${userId}`)
}